import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { EcmRouterModule, Link, LinkService, TrackingData } from '@ecm/router';

import { UniverseEnum } from '../../../../business/api/dashboard/universeEnum';
import { TerminatedContractViewModel } from '../../../../business/model/crossroads/contracts-options/terminated-contract.view-model';
import { ContractsViewModel } from '../../../../business/model/crossroads/contracts.view-model';
import { TrackedPage } from '../../../../business/model/tracking/trackedPage.enum';
import { ParamsUtils } from '../../../../utils/params.utils';
import { AbstractComponent } from '../../../shared/abstract.component';
import { CrossroadsUtils } from '../../utils/crossroads.utils';

@Component({
    selector: 'ecm-terminated-contract-bill',
    templateUrl: 'terminated-contract-bill.html',
    styleUrls: ['terminated-contract-bill.css'],
    standalone: true,
    imports: [NgClass, AsyncPipe, DatePipe, EcmRouterModule, TranslateModule],
})
export class TerminatedContractBillComponent extends AbstractComponent implements OnInit {
    @Input()
    public viewModel: ContractsViewModel;

    @Input()
    public hideBorder = true;

    @Input()
    public universe: UniverseEnum;

    public terminatedContractViewModel: TerminatedContractViewModel;

    public mixedSoshPicto = 'assets/dashboard/images/mini-logo-sosh.svg';
    public mixedOrangePicto = 'assets/dashboard/images/mini-logo-orange.png';

    public readonly ParamsUtils = ParamsUtils;

    public billLink: Link;

    public icon: string = null;

    public labelButton: string;

    private readonly billPageLinkUrl: string = 'facture-paiement/{{cid}}';

    /**
     * GA tracking area
     * @type {string}
     */
    private readonly trackingArea: string = 'care_selectionfacture_factures';

    private readonly translate = inject(TranslateService);
    private readonly linkService = inject(LinkService);

    public constructor() {
        super();
        this.translate.use('fr');
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.billLink = { inApp: this.billPageLinkUrl };
        if (this.viewModel.contract) {
            this.terminatedContractViewModel = this.viewModel.contract as TerminatedContractViewModel;
        }

        if (this.universe === UniverseEnum.MIXED) {
            this.icon =
                CrossroadsUtils.getIconBrand(this.universe, this.viewModel, this.terminatedContractViewModel) ===
                UniverseEnum.SOSH
                    ? this.mixedSoshPicto
                    : this.mixedOrangePicto;
        }
        const isSosh = this.isSoshBrand()();
        this.translate.get('dashboard.bills.button').subscribe((billsButton: any) => {
            this.labelButton = this.getLabelButton(isSosh, billsButton);
        });
    }

    /**
     * get label for button
     * @return {string}
     */
    public getLabelButton(isSosh: boolean, billButton: any): string {
        if (!isSosh && this.terminatedContractViewModel.brand === 'Sosh') {
            return billButton['soshLabel'];
        } else if (isSosh && this.terminatedContractViewModel.brand === 'Orange') {
            return billButton['orangeLabel'];
        } else {
            return billButton['paidYourBill'];
        }
    }

    /**
     * Go to contract bill page
     */
    public openBill(): void {
        const isSosh = this.isSoshBrand()();
        this.translate.get('dashboard.bills.button').subscribe((button: string) => {
            const link: Link = button['billPageLinkUrl'];
            let navigationExtras: NavigationExtras;
            if (!isSosh && this.viewModel.brand.toUpperCase() === UniverseEnum.SOSH) {
                navigationExtras = { queryParams: { sosh: '' } };
            } else if (isSosh && this.viewModel.brand.toUpperCase() === UniverseEnum.ORANGE) {
                navigationExtras = { queryParams: { orange: '' } };
            } else {
                navigationExtras = null;
            }
            this.linkService.openLink(
                link,
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.bills,
                        trackingArea: this.trackingArea,
                        trackingName: button['paidYourBill'],
                    },
                }),
                ParamsUtils.cidMap(this.terminatedContractViewModel.cid),
                navigationExtras,
            );
        });
    }
}
